module.exports = __webpack_public_path__ + "media/images/vector-98@2x-431703933826356fdbfc2eb2998d0127.png";